import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	"aria-label": "facebook source icon",
	style: { color: "#1877F2" },
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M36 4c-9 0-14 5-14 14v7h-8v11h8v24h12V36h10l2-11H34v-6c0-3 2-5 5-5h7V4h-10z"
	})
});
export default SvgFacebook;
